import { get, flow } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOptions = get('inventory.options.availabilityOptions');

export const getAvailabilityOptions = createSelector(getOptions, get('all'));

export const getIsFetching = flow(
  getOptions,
  get('fetching')
);

export const getIsFetched = flow(
  getOptions,
  get('fetched')
);

export const getFetchingError = flow(
  getOptions,
  get('fetchingError')
);
